export default "/images/annotation.svg?6dadf98c2142fc8cb3f5a0a92ea280b7";